// Storage utility for managing localStorage

const STORAGE_KEYS = {
    USER: 'user',
    USER_INFO: 'userInfo',
    TOKEN: 'token',
    ACCESS_TOKEN: 'accessToken',
    ID_TOKEN: 'idToken',
    REFRESH_TOKEN: 'refreshToken',
    TENANT_ID: 'tenantId',
    TENANT_INFO: 'tenantInfo',
    SITE_ID: 'siteId',
    ZONE_ID: 'zoneId',
} as const;

export const storage = {
    // User
    setUser: (user: any) => {
        localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
        localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(user));
    },
    getUser: () => {
        const user = localStorage.getItem(STORAGE_KEYS.USER) || localStorage.getItem(STORAGE_KEYS.USER_INFO);
        return user ? JSON.parse(user) : null;
    },
    removeUser: () => {
        localStorage.removeItem(STORAGE_KEYS.USER);
        localStorage.removeItem(STORAGE_KEYS.USER_INFO);
    },

    // Token (legacy support)
    setToken: (token: string) => {
        localStorage.setItem(STORAGE_KEYS.TOKEN, token);
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
    },
    getToken: () => {
        return localStorage.getItem(STORAGE_KEYS.TOKEN) || localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    },
    removeToken: () => {
        localStorage.removeItem(STORAGE_KEYS.TOKEN);
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    },

    // Access Token
    setAccessToken: (token: string) => {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
    },
    getAccessToken: () => {
        return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    },

    // ID Token
    setIdToken: (token: string) => {
        localStorage.setItem(STORAGE_KEYS.ID_TOKEN, token);
    },
    getIdToken: () => {
        return localStorage.getItem(STORAGE_KEYS.ID_TOKEN);
    },

    // Refresh Token
    setRefreshToken: (refreshToken: string) => {
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
    },
    getRefreshToken: () => {
        return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
    },
    removeRefreshToken: () => {
        localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    },

    // Tenant ID
    setTenantId: (tenantId: string) => {
        localStorage.setItem(STORAGE_KEYS.TENANT_ID, tenantId);
    },
    getTenantId: () => {
        return localStorage.getItem(STORAGE_KEYS.TENANT_ID);
    },
    removeTenantId: () => {
        localStorage.removeItem(STORAGE_KEYS.TENANT_ID);
    },

    // Tenant Info
    setTenantInfo: (tenantInfo: any) => {
        localStorage.setItem(STORAGE_KEYS.TENANT_INFO, JSON.stringify(tenantInfo));
    },
    getTenantInfo: () => {
        const info = localStorage.getItem(STORAGE_KEYS.TENANT_INFO);
        return info ? JSON.parse(info) : null;
    },

    // Site ID
    setSiteId: (siteId: string) => {
        localStorage.setItem(STORAGE_KEYS.SITE_ID, siteId);
    },
    getSiteId: () => {
        return localStorage.getItem(STORAGE_KEYS.SITE_ID);
    },
    removeSiteId: () => {
        localStorage.removeItem(STORAGE_KEYS.SITE_ID);
    },

    // Zone ID
    setZoneId: (zoneId: string) => {
        localStorage.setItem(STORAGE_KEYS.ZONE_ID, zoneId);
    },
    getZoneId: () => {
        return localStorage.getItem(STORAGE_KEYS.ZONE_ID);
    },
    removeZoneId: () => {
        localStorage.removeItem(STORAGE_KEYS.ZONE_ID);
    },

    // Clear all
    clearAll: () => {
        Object.values(STORAGE_KEYS).forEach(key => {
            localStorage.removeItem(key);
        });
    }
};